// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const CSSettingsContainer = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  padding: 0.75rem 1rem;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  display: flex;
  flex: 1;
  min-width: 0;

  // Increase padding for larger screens
  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1rem 1.5rem;
  };
`;

export const CSSettingsContent = styled.div`
  display: flex;
  gap: 2px;
`;

export const ParagraphUnitContainer = styled.div`
  padding-bottom: 1.5px;
  display: flex;
  align-items: flex-end;
`;
